import { useEffect, useState, useMemo } from "react";
import { useSelector } from 'react-redux';
import { useDrawRow } from "../hook/use_draw_row";
import { useFileErrors } from "../hook/use_file_errors";
import RemoveLine from "./remove_line";

const Body = () => {
    const showOnlyErrors = useSelector(state => state.errorFilter);
    const rowErrors = useSelector(state => state.rowErrors || {});
    const file = useSelector(state => state.file);
    const { getRow, createRow } = useDrawRow();
    const { saveErrors } = useFileErrors();
    const mappedFile =
        useMemo(() => {
            return (file || []).map((row, index) => createRow(row, index));
        }, [file]);

    useEffect(() => {
        saveErrors(mappedFile);
    }, [mappedFile]);

    const [openRemoveIndex, setOpenRemoveIndex] = useState(null);

    const handleOpenRemove = (index) => {
        setOpenRemoveIndex(index);
    };
    const handleCloseRemove = () => {
        setOpenRemoveIndex(null);
    };

    const rowHasErrors = (index) => {
        return !!rowErrors[index]?.hasError;
    };

    return (
        <tbody>
            {mappedFile.map((row, index) => {
                if (showOnlyErrors && !rowHasErrors(index)) return null;
                return (
                    <tr key={index}>
                        {getRow(row, index)}
                        <RemoveLine
                            index={index}
                            isOpen={openRemoveIndex === index}
                            onOpen={() => handleOpenRemove(index)}
                            onClose={handleCloseRemove}
                        />
                    </tr>
                );
            })}
        </tbody>
    )
};

export default Body;